export const emailKeys = {
  limit: () => ['EMAIL_LIMIT'] as const,
};
